import AdvDecResponseMappper from "../advanceDeclineStream/AdvDecResponseMappper";
import { STREAMING_TYPE } from "./IQuoteStreamRepo";
import NewsResponseMappper from "../liveNewsStream/NewsResponseMappper";
import MarketDepthResponseMapper from "../MarketDepthStream/MarketDepthResponseMappper";
export var streamKeys = [
    "symbol",
    "curPrice",
    "changePrice",
    "changePercentage",
    "updatedTime",
    "marketStatus",
    "oiChange",
    "oiChangePercentage",
    "volume",
    "openInterest",
    "futurePrice",
    "spotPrice",
    "bid",
    "ask",
    "iv",
    "high",
    "low",
    "open",
    "close",
    "rollOver",
    "rollOverCost",
    "rollOverCostPercentage",
    "totalTradedValue",
    "bidQty",
    "askQty",
    "avgTradedPrice",
    "premiumDiscount",
    "1WK_ChangePrice",
    "1WK_ChangePercentage",
    "1MN_ChangePrice",
    "1MN_ChangePercentage",
    "1YR_ChangePrice",
    "1YR_ChangePercentage",
    // "3MN_ChangePrice", //33
    // "3MN_ChangePercentage", //33
    "mcap",
    "hCL",
    "lCL", //35
];
var QuoteResponseMappper = /** @class */ (function () {
    function QuoteResponseMappper() {
        this.AdvResponseMapper = new AdvDecResponseMappper();
        this.newsResponseMapper = new NewsResponseMappper();
        this.marketDepthResponseMapper = new MarketDepthResponseMapper();
    }
    QuoteResponseMappper.prototype.formatResponse = function (streamRes, cbs) {
        var _this = this;
        try {
            var ResData_1 = JSON.parse(streamRes).response;
            switch (ResData_1.streaming_type) {
                case STREAMING_TYPE.MINIQUOTE:
                case STREAMING_TYPE.QUOTE:
                    var formatData_1 = {};
                    cbs.streamKey.forEach(function (key) {
                        formatData_1[key] = _this.getValueKey(ResData_1.data, key);
                    });
                    cbs.cb(formatData_1);
                    break;
                case STREAMING_TYPE.MARKET_STATUS:
                    var localStatus = JSON.parse(localStorage.getItem("marketStatus"));
                    if (!localStatus || localStatus === null) {
                        localStatus = {
                            status: {
                                BFO: "Closed",
                                NFO: "Closed",
                                BSE: "Closed",
                                NSE: "Closed",
                                NCDX: "Closed",
                                MCX: "Closed",
                                CDS: "Closed",
                                NCDEX: "Closed",
                            },
                            lut: "",
                        };
                    }
                    localStatus.status[Object.keys(ResData_1.data.status)[0]] =
                        Object.values(ResData_1.data.status)[0] === 1 ? "Open" : "Closed";
                    localStatus.lut = ResData_1.data.lut;
                    localStorage.setItem("marketStatus", JSON.stringify(localStatus));
                    cbs.cb({
                        status: this.formatStatusResponse(ResData_1.data.status),
                        lut: ResData_1.data.lut,
                    });
                    break;
                case STREAMING_TYPE.ADVDEC:
                    this.AdvResponseMapper.formatResponse(streamRes, cbs.cb);
                    break;
                case STREAMING_TYPE.NEWS:
                    this.newsResponseMapper.formatResponse(streamRes, cbs.cb);
                    break;
                case STREAMING_TYPE.QUOTE2:
                    this.marketDepthResponseMapper.formatResponse(streamRes, cbs.cb);
                    break;
                default:
                    break;
            }
        }
        catch (error) {
            console.log("Stream Response Format error", error);
        }
    };
    QuoteResponseMappper.prototype.formatStatusResponse = function (inputData) {
        return Object.keys(inputData).reduce(function (acc, key) {
            acc[key] = inputData[key] === 1 ? "Open" : "Closed";
            return acc;
        }, {});
    };
    QuoteResponseMappper.prototype.getValueKey = function (data, key) {
        switch (key) {
            case streamKeys[0]:
                return data["sym"];
            case streamKeys[1]:
                return data["ltp"];
            case streamKeys[2]:
                return data["chg"];
            case streamKeys[3]:
                return data["chgp"];
            case streamKeys[4]:
                return data["lut"];
            case streamKeys[5]:
                return data["mO"] === "0" ? "Closed" : "Open";
            case streamKeys[6]:
                return data["oiChg"];
            case streamKeys[7]:
                return data["oiChgp"];
            case streamKeys[8]:
                return data["vol"];
            case streamKeys[9]:
                return data["oI"];
            case streamKeys[10]:
                return data["futPrc"];
            case streamKeys[11]:
                return data["spotPrc"];
            case streamKeys[12]:
                return data["bPr"];
            case streamKeys[13]:
                return data["aPr"];
            case streamKeys[14]:
                return data["ltpivfut"];
            case streamKeys[15]:
                return data["h"];
            case streamKeys[16]:
                return data["l"];
            case streamKeys[17]:
                return data["o"];
            case streamKeys[18]:
                return data["c"];
            case streamKeys[19]:
                return data["rocost"];
            case streamKeys[20]:
                return data["rocostp"];
            case streamKeys[21]:
                return data["roperc"];
            case streamKeys[22]:
                return data["ntTrdVal"];
            case streamKeys[23]:
                return data["bSz"];
            case streamKeys[24]:
                return data["aSz"];
            case streamKeys[25]:
                return data["avgPrc"];
            case streamKeys[26]:
                return data["premDisc"];
            case streamKeys[27]:
                return data["wChg"];
            case streamKeys[28]:
                return data["wChgp"];
            case streamKeys[29]:
                return data["mChg"];
            case streamKeys[30]:
                return data["mChgp"];
            case streamKeys[31]:
                return data["yChg"];
            case streamKeys[32]:
                return data["yChgp"];
            case streamKeys[33]:
                return data["mcap"];
            case streamKeys[34]:
                return data["hCL"];
            case streamKeys[35]:
                return data["lCL"];
            default:
        }
    };
    return QuoteResponseMappper;
}());
export default QuoteResponseMappper;
